import m from "mithril";

export const Separator: m.Component = {
  view() {
    return m("div.my-4.border-t.border-dashed");
  },
};